module.exports = __webpack_public_path__ + "fonts/montserrat-mediumitalic-webfont.fd45ac6.woff2";